export { default } from "bullitttime-embermodelsevent/adapters/result";
